export const UsersStore = {
    namespaced: true,
    state: {
        users: [],
        user:{},
        userInfo: {}
    },
    mutations: {
        setUsers(state: any, response: any) {
            state.users = response;
        },
        setUser(state: any, response: any) {
            state.user = response;
        },
        setUserInfo(state: any, response: any) {
            state.userInfo = response;
        }
    },
    actions:{
        setUsers(context: any, response: any) {
            context.commit('setUsers', response);
        },
        setUser(context: any, response: any) {
            context.commit('setUser', response);
        },
        setUserInfo(context: any, response: any) {
            context.commit('setUserInfo', response);
        }
    },
    getters: {
        getUsers: (state: any) => state.users,
        getUser: (state: any) => state.user,
        getUserInfo: (state: any) => state.userInfo
    }
}